<template>
  <div>
    <button-scroll-to-top></button-scroll-to-top>
    <banner v-if="banner" :bannerContent="banner" />
    <div class="content p-0" ref="productList" style="position: relative">
      <div v-if="checkSettingChatWork">
        <no-chat-work></no-chat-work>
      </div>
      <div v-if="checkSettingNoDanboard">
        <no-danboard></no-danboard>
      </div>
      <div v-if="checkInvalidSettingSpAccount">
        <invalid-setting-sp-account></invalid-setting-sp-account>
      </div>

      <no-multi-channel-service v-if="noEvidenceImage" />

      <div class="alert alert-danger text-center space-box-alert-custom" v-if="$store.getters.getUser.memo" v-html="replaceHTMLSellerInfo($store.getters.getUser.memo)">
      </div>

      <p v-show="checkDisabledAddButton" class="text-left mr-t-10">只今、商品情報を最新に更新中...</p>

      <div v-if="!noEvidenceImage">
        <products-not-authenticate v-if="haveAmazonInfo === false"></products-not-authenticate>
        <product-no-item v-else-if="countData === 0"></product-no-item>

        <div v-show="haveAmazonInfo && countData > 0">
          <div class="box-search-keyword-get-lastest">
            <get-latest-products-button
              :key="`products-group-list`"
              getFrom="list"
              @handleGetLatestProducts="handleGetLatestProducts()"
            />
            <div class="box-search-keyword">
              <div class="item">
                <div class="item-addon">
                  <input v-model.trim="search" type="text" class="form-control input-search-keyword" placeholder="ASIN、SKU、FNSKU、商品名" @keydown.enter="onHandleSearch">
                  <span class="clear-keyword-search" @click.prevent="clearKeywordSearch()"><i class="fa fa-times"></i></span>
                </div>
              </div>
              <div class="item">
                <button type="button" class="btn btn-primary btn-search mr-r-10" @click="onHandleSearch()">検索</button>
                <span>{{ filterAllDataCount }} 商品</span>
              </div>
            </div>
          </div>
          <div class="box-search-display-setting flex-content-center">
            <button type="button" class="btn btn-primary bd-rds-5 mr-r-10 w-165" @click="openSearch">倉庫フィルターの設定</button>
            <div class="box-search-setting">
              <div class="box-variation-display-setting-status">
                <div class="search-title">バリエーション表示:</div>
                <div class="radio-inline" v-for="variationSetting in arrVariationDisplaySettingStatus" :key="`variation-display-setting-${variationSetting.id}`">
                  <input type="radio" :value="variationSetting.id" :id="`variation-display-setting-status-${variationSetting.id}`"
                  class="filter-variation-display-setting" name="filter-variation-display-setting-status" :checked="checkVariationDisplaySetting(variationSetting.id)" @click="changeVariationDisplaySettingStatus(variationSetting.id)">
                  <label :for="`variation-display-setting-status-${variationSetting.id}`">{{ variationSetting.text }}</label>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-warning" @click.prevent="openModalUpload()">受取金額をCSVで一括変更する</button>
          </div>
          <div id="product-list">
            <product-grouped-table
              :url="'ParentProductGroup'"
              :extraUrl="['Product/get-image-name']"
              :extraUrlMode="true"
              @countData="countData = $event"
              @filterAllDataCount="filterAllDataCount = $event"
              :filters="filters"
              :columns="columns"
              :needExtraData="true"
              :checkedItems="checkedItems"
              :isChangeItems="isChangeItems"
              :paginationStorageKey="'productList'"
              @extraData="extraData = $event"
              @checkBoxAll="checkBoxAll"
              @handleDeleteAllItems="showAlert"
              @handleChangeAllItems="updateProducts"
              @fetchedDataLoading="fetchedDataLoading"
              @handleChangeParentCheckedItems="handleChangeParentCheckedItems"
              @handleChangeAmountReceived="handleChangeAmountReceived"
              @handleCheckSellmonScOffer="handleCheckSellmonScOffer"
              @handleCheckSellmonAcrossOffer="handleCheckSellmonAcrossOffer"
              ref="productTable"
            >
              <template slot="deleteCheckBox" slot-scope="props">
                <div v-if="props.rowData.isParent">
                  <input class="checked-all-child" type="checkbox" :value="props.rowData.asin" v-model="parentCheckedItems" @change="refreshCheckedAllChild($event)">
                </div>
                <div v-else>
                  <input type="checkbox" :value="props.rowData.asin" v-model="checkedItems" @change="refreshCheckAll">
                </div>
              </template>
              <template slot="judgmentStatusCode" slot-scope="props">
                <div>
                  <div class="flexbox justify-center gap-10">
                    <span class="box-delivery-judgment-status" :class="getJudgmentStatusClass(props.rowData)">
                      {{props.rowData.judgmentStatus}}
                    </span>
                    <span v-if="props.rowData.reviewDays !== null" class="font-bold" style="color: #767171;">
                      審査完了まで
                      <br>
                      <div class="flex flex-content-center gap-5">
                        <span class="text-rotate">あと</span>
                        <span class="text-size-28" style="color: #388e3c;">{{ getReviewDays(props.rowData) }}</span>
                      </div>
                    </span>
                  </div>
                  <div v-if="props.rowData.judgmentStatusCode === '9'" class="mr-t-10">
                    <button class="btn btn-warning" @click="reApplyProduct(props.rowData)">再申請</button>
                  </div>
                  <div v-if="props.rowData.judgmentStatusCode === '2' && (props.rowData.deleteFlg === '0' || props.rowData.deleteFlg === '2')" class="box-toggle-judgment-status">
                    <input type="checkbox" :checked="props.rowData.deleteFlg === '0'" class="judgment-status-input" :id="`judgment-status-` + props.rowData.asin">
                    <label @click="updateProductDeleteFlag(props.rowData)" class="judgment-status-label" :for="`judgment-status-` + props.rowData.asin"></label>
                  </div>
                </div>
              </template>
              <template slot="productName" slot-scope="props">
                <div class="flexbox justify-between flex-nowrap flex-content-start gap-10">
                  <div>
                    <div class="flexbox flex-nowrap gap-10">
                      <loading-block class="product-image" :value="props.rowData.image" type="image">
                        <img :src="props.rowData.image" alt="" class="product-img group-table__product_img product-image" :class="[{'w-40 h-40': props.rowData.isParent}]">
                      </loading-block>
                      <div class="full-width">
                        <div class="tooltip-wrapper">
                          <loading-block :value="props.rowData.productName" type="string" :class="{ 'group-table__product_name': props.isGroupTable, 'product-name': true }">
                            <a
                              :href="'https://www.amazon.co.jp/gp/offer-listing/' + props.rowData.asin"
                              target="_blank"
                              class="text--underline product-name"
                              >
                              {{ sliceProductName(props.rowData.isParent, props.rowData.productName) }}
                            </a>
                            <span class="tooltip-text">{{ props.rowData.productName }}</span>
                          </loading-block>
                        </div>
                        <div v-if="!props.rowData.isParent" class="flexbox">
                          <div class="flexbox gap-5 mr-r-10">
                            <span>
                              <b>ASIN：</b>
                              {{ props.rowData.asin }}
                            </span> /
                            <span>
                              <b>SKU：</b>
                              {{ props.rowData.sku }}
                            </span> /
                            <span>
                              <b>FNSKU：</b>
                              {{ props.rowData.fnsku }}
                            </span>
                          </div>
                          <div v-if="props.rowData.skus && Object.keys(props.rowData.skus).length > 1" :class="props.rowData.asin === props.data[props.data.length - 1].asin ? 'dropup' : 'dropdown'">
                            <a class="text--underline" @click.stop>
                            その他 {{ Object.keys(props.rowData.skus).length - 1 }} 件
                            </a>
                            <ul class="dropdown-menu">
                              <li
                                v-for="([fnsku, sku], index) in Object.entries(props.rowData.skus).filter(([key]) => key !== props.rowData.fnsku)"
                                :key="index"
                              >
                                <div><b>SKU：</b>{{ sku }}</div>
                                <div><b>FNSKU：</b>{{ fnsku }}</div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div v-else class="product-asin"><b>ASIN：</b> {{ props.rowData.asin }}</div>
                        <div  v-if="!props.rowData.isParent" class="flexbox gap-10">
                          <loading-block :value="props.rowData.amazonPrice" type="money">
                            <span class="">Amazon価格：¥</span><span class="text-price-number">{{formatAmount(props.rowData.amazonPrice)}}</span>
                          </loading-block>
                          <div class="flexbox gap-10">
                            <div v-if="props.rowData.promotionRegistered" class="label-running-ads">
                              広告運用中
                            </div>
                            <div v-if="props.rowData.taxWord" class="mr-r-10 product-tax-word">
                              {{props.rowData.taxWord}}
                            </div>
                            <div class="mr-r-10 product-bubble-wrapper" data-toggle="modal" data-target="#imageadd" @click="openUploaderModal(props.rowData.asin, props.rowData.dropboxShareUrl)" ref="addProductBtn">
                              <div v-show="showImageUploaderBubble" class="product-bubble image-uploader-bubble">
                                審査資料のアップロードはこちら
                              </div>
                              <i aria-hidden="true" class="fa fa-paperclip fa-2x product-image-uploader-icon" :class="[props.rowData.dropboxShareUrl ? 'product-image-uploader-icon-hilight' : '']" @mouseover="handleImageUploadMouseOver($event)" @mouseleave="handleImageUploadMouseLeave($event)" />
                              <a href="javascript:void(0)" class="text--underline product-image-uploader" @mouseover="handleImageUploadMouseOver($event)" @mouseleave="handleImageUploadMouseLeave($event)">審査資料</a>
                            </div>
                            <div class="product-bubble-wrapper analytics-icon text-center">
                              <i aria-hidden="true" class="fa fa-bar-chart fa-2x product-image-uploader-icon-hilight" />
                              <a href="javascript:void(0)" class="text--underline product-image-uploader" @click="handleClickViewProductAnalytics(props.rowData)">商品分析</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="!props.rowData.isParent && props.rowData.mark">
                      <div v-if="props.rowData.hasScOffer" class="alert alert-warning mark-warning product-mark-warning" :class="[!(props.rowData.mark && props.rowData.mark !== 'NULL') ? 'mark-warning-visibility-hidden' : '']" role="alert" style="margin-bottom: 5px;">
                        <i class="text-warning fa fa-exclamation-triangle text-size-20 warning-icon mark-warning" aria-hidden="true"></i>
                        <span class="mark-warning" v-html="replaceHTMLSellerInfo(props.rowData.mark)"></span>
                      </div>
                      <div v-else class="alert alert-warning mark-warning product-mark-warning" :class="[!(props.rowData.mark && props.rowData.mark !== 'NULL') ? 'no-pc' : '']" role="alert" style="margin-bottom: 5px;">
                        <i class="text-warning fa fa-exclamation-triangle text-size-20 warning-icon mark-warning" aria-hidden="true"></i>
                        <span class="mark-warning" v-html="replaceHTMLSellerInfo(props.rowData.mark)"></span>
                      </div>
                    </div>
                  </div>
                  <div v-if="!props.rowData.isParent" class="flex justify-right flex-nowrap gap-10">
                    <div v-if="props.rowData.hasScOffer && filters.warehouse.includes('salmonSc')" class="box-warehouse box-warehouse-sc">
                      <div class="flex gap-10">
                        <warehouse-icon
                          :key="`sc-icon-${props.rowData.asin}}`"
                          :iconImage="icons.salmonSc"
                          :warehouseName="`STOCKCREW倉庫`"
                          :iconClassName="`sc-icon`"
                          :imageClassName="`sc-image`"
                          style="width: 30%;"
                        />
                        <div class="flexbox justify-right">
                          <div class="flexbox flex-nowrap gap-5">
                            <span class="w-80 text-right">受取金額</span>
                            <span>¥</span>
                            <product-input-money
                              :key="'products-sc-offerPrice-' + props.rowData.asin"
                              :ref="'products-sc-offerPrice-' + props.rowData.asin"
                              :value="props.rowData.scOfferPrice"
                              validation="required|moneyMin:1|numberLength:6"
                              :product="props.rowData"
                              :warehouseType="`sc`"
                              :class="{ 'alert-warning-text': comparePrice(props.rowData.scOfferPrice, props.rowData.amazonPrice), 'table-alert': changePrice(props.rowData.asin, props.rowData.scOfferPrice, 'sc') }"
                              :customStyle="{color: '#800000', 'font-size': '20px'}"
                              @input="scCheckBulkUpdate"
                              class="product-input-money"
                            />
                          </div>
                          <div class="flexbox flex-nowrap gap-5">
                            <span class="w-80 text-right">予想出品金額</span>
                            <span>¥</span>
                            <span class="w-100 expected-amount">{{scExpectedAmount(props.rowData.scOfferPrice)}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="flexbox w-rate-100">
                        <div class="flex gap-10 pd-t-10">
                          <span class="text-gray">保管サイズ</span>
                          <span v-if="props.rowData.scStorageSize">
                            {{ props.rowData.scStorageSize}}
                            ({{ props.rowData.scSizeName}})
                          </span>
                          <span v-else>-</span>
                        </div>
                        <div class="flexbox justify-between flex-content-baseline w-rate-100">
                          <div class="flex gap-20">
                            <span class="text-gray">送料見積</span>
                            <span>{{ props.rowData.scShippingFee ? '¥' + formatQuantity(props.rowData.scShippingFee) : '-' }}</span>
                          </div>
                          <div>
                            <span class="text-right">
                              <span class="text-size-28 text-primary font-bold" style="line-height: 28px;">{{ formatQuantity(props.rowData.scInventoryQuantity) }}</span>
                              個
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="props.rowData.hasAcrossOffer && filters.warehouse.includes('salmonAcross')" class="box-warehouse box-warehouse-across">
                      <div class="flex gap-10">
                        <warehouse-icon
                          :key="`across-icon-${props.rowData.asin}}`"
                          :iconImage="icons.salmonAcross"
                          :warehouseName="`ACROSS倉庫`"
                          :iconClassName="`across-icon`"
                          :imageClassName="`across-image`"
                          style="width: 30%;"
                        />
                        <div class="flexbox justify-right">
                          <div class="flexbox flex-nowrap gap-5">
                            <span class="w-80 text-right">受取金額</span>
                            <span>¥</span>
                            <product-input-money
                              :key="'products-across-offerPrice-' + props.rowData.asin"
                              :ref="'products-across-offerPrice-' + props.rowData.asin"
                              :value="props.rowData.acrossOfferPrice"
                              validation="required|moneyMin:1|numberLength:6"
                              :product="props.rowData"
                              :warehouseType="`across`"
                              :class="{ 'alert-warning-text': comparePrice(props.rowData.acrossOfferPrice, props.rowData.amazonPrice), 'table-alert': changePrice(props.rowData.asin, props.rowData.acrossOfferPrice, 'across') }"
                              :customStyle="{color: '#800000', 'font-size': '20px'}"
                              @input="acrossCheckBulkUpdate"
                              class="product-input-money"
                            />
                          </div>
                          <div class="flexbox flex-nowrap gap-5">
                            <span class="w-80 text-right">予想出品金額</span>
                            <span>¥</span>
                            <span class="w-100 expected-amount">{{expectedAmount(props.rowData.acrossOfferPrice)}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="flexbox w-rate-100">
                        <div class="flex gap-10 pd-t-10">
                          <span class="text-gray">保管サイズ</span>
                          <span v-if="props.rowData.acrossStorageSize">
                            {{ props.rowData.acrossStorageSize}}
                          </span>
                          <span v-else>-</span>
                        </div>
                        <div class="flexbox justify-between flex-content-baseline w-rate-100">
                          <div class="flex gap-20">
                            <span class="text-gray">送料見積</span>
                            <span>{{ props.rowData.acrossShippingFee ? '¥' + formatQuantity(props.rowData.acrossShippingFee) : '-' }}</span>
                          </div>
                          <div>
                            <span class="text-right">
                              <span class="text-size-28 text-primary font-bold" style="line-height: 28px;">{{ formatQuantity(props.rowData.acrossQuantity) }}</span>
                              個
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="filters.warehouse.includes('Amazon')" class="box-warehouse">
                      <div class="flex gap-10">
                        <warehouse-icon
                          :key="`amazon-icon-${props.rowData.asin}}`"
                          :iconImage="icons.Amazon"
                          :warehouseName="`Amazon倉庫`"
                          :iconClassName="`amazon-icon`"
                          :imageClassName="`amazon-image`"
                          style="width: 30%;"
                        />
                        <div class="flexbox justify-right">
                          <div class="flexbox flex-nowrap gap-5">
                            <span class="w-80 text-right">受取金額</span>
                            <span>¥</span>
                            <product-input-money
                              :key="'products-amazon-offerPrice-' + props.rowData.asin"
                              :ref="'products-amazon-offerPrice-' + props.rowData.asin"
                              :value="props.rowData.offerPrice"
                              validation="required|moneyMin:1|numberLength:6"
                              :product="props.rowData"
                              :class="{ 'alert-warning-text': comparePrice(props.rowData.offerPrice, props.rowData.amazonPrice), 'table-alert': changePrice(props.rowData.asin, props.rowData.offerPrice) }"
                              :customStyle="{color: '#800000', 'font-size': '20px'}"
                              @input="checkBulkUpdate"
                              class="product-input-money"
                              style="width: 100px;"
                            />
                          </div>
                          <div class="flexbox flex-nowrap gap-5">
                            <span class="w-80 text-right">予想出品金額</span>
                            <span>¥</span>
                            <span class="w-100 expected-amount">{{expectedAmount(props.rowData.offerPrice)}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="flexbox justify-between flex-content-baseline w-rate-100">
                        <div class="w-rate-100"></div>
                        <div class="flex gap-20">
                          <span class="text-gray">送料見積</span>
                          <shipping-fee :key="props.rowData.asin" :rowData="props.rowData" :customStyle="{'font-size': '12px'}" checkFrom="list" />
                        </div>
                        <div>
                          <span class="text-right">
                            <span class="text-size-28 text-primary font-bold" style="line-height: 28px;">{{ formatQuantity(props.rowData.numberOfStock) }}</span>
                            個
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template slot="action" slot-scope="props">
                <div :class="[!props.rowData.isChanged ? 'product-update-visibility-hidden' : '']">
                  <span :id="`offer-price-` + props.rowData.asin" :class="`btn btn-warning offer-price-btn btn-update-offer-price`" @click="updateOfferPrice(props.rowData)">保存</span>
                </div>
                <div class="mr-t-10">
                  <button type="button" class="btn btn-delete-product" @click="showAlertDeleteOneItem(props.rowData)">削除</button>
                </div>
              </template>
            </product-grouped-table>
          </div>
        </div>
      </div>
    </div>
    <image-add
      ref="addImageModal"
      :asin="this.asin"
      :shareLink="this.dropboxShareUrl"
      :size="`modal-xs`"
      @refresh="reRefreshTable"
      @close="closeUploaderModal"
    ></image-add>
    <upgrade-plan-modal
      v-if="isShowUpgradePlanModal"
      @close="closeUpgradePlanModal"
    />
    <change-amount-received-bulk
      :numberOfStockImage="icons.Amazon"
      :scTransportImage="icons.salmonSc"
      :acrossTransportImage="icons.salmonAcross"
      :checkedItems="checkedItems"
      :hasSellmonScOffers="hasSellmonScOffers"
      :hasSellmonAcrossOffers="hasSellmonAcrossOffers"
      v-if="isShowChangeAmountReceivedModal"
      @close="closeChangeAmountReceivedModal"
      @handleClickBulkUpdate="handleClickBulkUpdate"
    />
    <search-modal
      v-if="openSearchModal"
      :icons="icons"
      :arrJudgmentStatus="arrJudgmentStatus"
      :arrAmountReceived="arrAmountReceived"
      :arrWarehouse="arrWarehouse"
      :arrStockStatus="arrStockStatus"
      :filters="filters"
      @close="closeSearch"
      @settingSearch="settingSearch"
    />
    <modal-delete-alert key="`delete-all-item`" v-if="isShowAlert" @close="closeAlert" @confirm="deleteProduct" :message="alertMessage"></modal-delete-alert>
    <modal-delete-alert key="`delete-one-item`" v-if="isShowAlertDeleteOneItem" @close="closeAlertDeleteOneItem" @confirm="deleteProductItem"></modal-delete-alert>
    <upload-csv-modal
      v-if="isShowUploadModal"
      :btnUploadText="'アップロード'"
      :header="'変更したい商品・受取金額のデータをアップロードしてください'"
      :title="'テンプレートファイルにはすべてのASIN、受取金額のリストが入力されています'"
      :uploadUrl="'Products/amount-received/upload'"
      @handleDownloadTemplate="handleDownloadTemplate"
      @handleUpload="handleUpload"
      @handleUploadSuccess="handleUploadSuccess"
      @close="closeUploadModal"
    />
    <confirm-change-price-modal
      v-if="isShowConfirmChangeModal"
      :data="confirmChangeData"
      :isDisableSubmit="disableSubmitChangePrice"
      @reUpload="reUpload"
      @handleSubmitChange="handleUpdateAmountReceivedByFile"
      @close="closeConfirmChangeModal"
    />
    <modal-alert
      v-if="isShowChangePriceCompleteModal"
      :message="'受取金額の変更が完了しました'"
      :customBodyClass="`text-center`"
      @close="closeChangePriceCompleteModal"
    />
  </div>
</template>
<script>
import ProductsNotAuthenticate from '@/view/productsNew/ProductsNewNotAuthenticate'
import ProductNoItem from '@/view/productsNew/ProductsNewNoItem'
import ImageAdd from '@/view/productsNew/ProductNewImageAdd'
import NoDanboard from '@/components/NoDanboard'
import NoChatWork from '@/components/NoChatWork'
import InvalidSettingSpAccount from '@/components/InvalidSettingSpAccount'
import InputText from '@/components/InputText'
import InputMoney from '@/components/InputMoney'
import LoadingBlock from '@/components/LoadingBlock'
import Util, { replaceHTMLSellerInfo } from '@/common/utility'
import ProductService from '@/services/productservice'
import SettingService from '@/services/settingservice'
import ModalDeleteAlert from '@/components/ModalDeleteAlert'
import ModalAlert from '@/components/ModalAlert'
import ShippingFee from '@/components/ShippingFee'
import GetLatestProductsButton from '@/components/GetLatestProductsButton'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import ProductGroupedTable from '@/view/productsNew/ProductGroupedTable'
import ProductAnalytics from '@/components/ProductAnalytics'
import ButtonScrollToTop from '@/components/ButtonScrollToTop'
import NoMultiChannelService from '@/components/NoMultiChannelService'
import UserService from '@/services/userservice'
import { mapGetters } from 'vuex'
import ProductInputMoney from '@/view/productsNew/ProductInputMoney'
import WarehouseIcon from '@/view/productsNew/WarehouseIcon'
import AnalyticsService from '../../services/analyticsservice'
import UpgradePlanModal from '@/view/warehouses/UpgradePlanModal'
import ChangeAmountReceivedBulk from '@/view/productsNew/ChangeAmountReceivedBulkModal'
import SearchModal from '@/view/productsNew/SearchModal'
import Banner from './Banner'
import UploadCsvModal from '@/components/UploadCsvModal'
import ConfirmChangePriceModal from './ConfirmChangePriceModal'
import moment from 'moment'

export default {
  props: {
    hasRefreshGroupTable: {
      type: Boolean,
      default: false
    },
    currentTab: {
      type: String,
      default: ''
    },
    banner: {
      type: String,
      default: ''
    }
  },
  components: {
    ProductsNotAuthenticate,
    ProductNoItem,
    ImageAdd,
    InputText,
    InputMoney,
    ModalDeleteAlert,
    ModalAlert,
    LoadingBlock,
    NoDanboard,
    NoChatWork,
    InvalidSettingSpAccount,
    ShippingFee,
    GetLatestProductsButton,
    ProductGroupedTable,
    ProductAnalytics,
    ButtonScrollToTop,
    NoMultiChannelService,
    ProductInputMoney,
    WarehouseIcon,
    UpgradePlanModal,
    ChangeAmountReceivedBulk,
    SearchModal,
    Banner,
    UploadCsvModal,
    ConfirmChangePriceModal
  },
  data () {
    return {
      err: null,
      haveAmazonInfo: null,
      countData: null,
      filterAllDataCount: null,
      isShowAlert: false,
      isShowModal: false,
      isAddProduct: false,
      isShowUpgradePlanModal: false,
      isShowChangeAmountReceivedModal: false,
      hasSellmonScOffers: false,
      hasSellmonAcrossOffers: false,
      alertMessage: null,
      loadingButton: true,
      loader: null,
      extraData: null,
      resetValidator: true,
      search: '',
      originalData: [],
      asin: '',
      dropboxShareUrl: '',
      columns: [
        {
          title: '',
          name: 'deleteCheckBox',
          label: '<input type="checkbox" id="product-delete-checkbox-all">',
          field: 'deleteCheckBox',
          customCell: true,
          cellClass: 'text-center align-middle',
          headerClass: 'w-30',
          sortable: false,
          checkable: true,
          thClass: 'grouped-table-header',
          tdClass: 'align-middle',
          width: '30px'
        },
        {
          title: 'ステータス',
          sortable: false,
          name: 'judgmentStatusCode',
          label: 'ステータス',
          field: 'judgmentStatusCode',
          customCell: true,
          cellClass: 'text-center align-middle judgment-status',
          headerClass: 'w-xl-100',
          thClass: 'grouped-table-header',
          tdClass: 'text-center align-middle',
          width: '130px',
          minWidth: '130px'
        },
        {
          title: '商品情報',
          sortable: false,
          name: 'productName',
          label: '<div class="flexbox justify-between"><span>商品情報</span><span>倉庫毎の情報 ※各金額は税込金額とする</span></div>',
          field: 'productName',
          customCell: true,
          cellClass: 'text-left product-list-name',
          headerClass: 'grouped-table-header',
          thClass: 'grouped-table-header product-name',
          minWidth: '552px'
        },
        {
          title: '更新',
          name: 'action',
          label: '',
          field: 'action',
          customCell: true,
          cellClass: 'text-center update-button',
          headerClass: 'w-80',
          sortable: false,
          thClass: 'grouped-table-header',
          tdClass: 'text-center',
          width: '80px'
        }
      ],
      arrJudgmentStatus: [
        {
          id: '',
          text: 'すべて'
        },
        {
          id: '審査中',
          text: '審査中'
        },
        {
          id: '出品中',
          text: '出品中'
        },
        {
          id: '停止中',
          text: '停止中'
        },
        {
          id: '審査NG',
          text: '審査NG'
        },
        {
          id: '出品NG',
          text: '出品NG'
        }
      ],
      arrAmountReceived: [
        {
          id: '',
          text: 'すべて'
        },
        {
          id: '1',
          text: 'ACROSS倉庫、STOCKCREW倉庫 ≧ Amazon倉庫'
        }
      ],
      arrWarehouse: [
        {
          id: 'Amazon',
          text: 'amazon'
        },
        {
          id: 'salmonAcross',
          text: 'salmonAcross'
        },
        {
          id: 'salmonSc',
          text: 'salmonSc'
        }
      ],
      arrStockStatus: [
        {
          id: '',
          text: 'すべて'
        },
        {
          id: '0',
          text: '在庫あり'
        },
        {
          id: '1',
          text: '在庫なし'
        }
      ],
      filters: {
        keyword: '',
        judgmentStatus: '',
        stockStatus: '',
        warehouse: ['Amazon', 'salmonAcross', 'salmonSc'],
        amountReceived: ''
      },
      deleteItem: {},
      isShowAlertDeleteOneItem: false,
      hasAmazonthrottleError: false,
      modalProductAnalyticsScrollNumber: null,
      modalDeleteAllItemsScrollNumber: null,
      arrVariationDisplaySettingStatus: [
        {
          id: '0',
          text: '閉じる'
        },
        {
          id: '1',
          text: '開く'
        }
      ],
      showImageUploaderBubble: false,
      showAnalyticsBubble: false,
      checkAll: false,
      checkedItems: [],
      parentCheckedItems: [],
      isChangeItems: false,
      privateItemLoader: null,
      openSearchModal: false,
      isShowUploadModal: false,
      isShowConfirmChangeModal: false,
      isShowChangePriceCompleteModal: false,
      confirmChangeData: [],
      disableSubmitChangePrice: true
    }
  },
  computed: {
    checkDisabledAddButton () {
      return this.loadingButton
    },
    checkSettingChatWork () {
      return this.$store.getters.getUser.chatWorkFlg !== '2'
    },
    checkSettingNoDanboard () {
      return this.$store.getters.getUser.danboardFlg !== '2'
    },
    checkInvalidSettingSpAccount () {
      return this.$store.getters.getUser.invalidSettingSpAccount
    },
    analyticsIconImage () {
      return '/static/dists/img/analytics_icon.png'
    },
    ...mapGetters({
      userInfo: 'getUser',
      icons: 'getWareHouseIcons'
    }),
    noEvidenceImage () {
      return ['0', '9'].includes(this.userInfo.multiChannelSenderFlg)
    },
    isBasicPlan () {
      return this.userInfo.memberPlan === '0'
    }
  },
  created () {
    this.init()
  },
  methods: {
    replaceHTMLSellerInfo,
    // Amazonの価格より50％以上高い時, 50％以上安い時警告
    comparePrice (offerPrice, amazonPrice) {
      var checkResult = false
      var inputPrice = Number.parseInt(offerPrice)
      var basePrice = Number.parseInt(amazonPrice)
      if (this.isNumber(inputPrice) && this.isNumber(basePrice) && basePrice > 0) {
        const halfPrice = basePrice * 0.5
        if (inputPrice <= halfPrice) {
          checkResult = true
        }
        const oneHalfPrice = basePrice * 1.5
        if (inputPrice >= oneHalfPrice) {
          checkResult = true
        }
        if ((inputPrice > halfPrice) && (inputPrice < oneHalfPrice)) {
          checkResult = false
        }
      }
      return checkResult
    },
    isNumber (numVal) {
      // チェック条件パターン
      var pattern = /^[-]?([1-9]\d*|0)(\.\d+)?$/
      // 数値チェック
      return pattern.test(numVal)
    },
    changePrice (asin, offerPrice, warehouseType = 'amazon') {
      var checkResult = false
      const baseData = this.$refs.productTable.originalData
      const targetData = baseData.find(item => item.asin === asin)
      if (targetData) {
        if (warehouseType === 'sc') {
          if (targetData.scOfferPrice !== offerPrice) {
            checkResult = true
          }
        }
        if (warehouseType === 'across') {
          if (targetData.acrossOfferPrice !== offerPrice) {
            checkResult = true
          }
        }
        if (warehouseType === 'amazon') {
          if (targetData.offerPrice !== offerPrice) {
            checkResult = true
          }
        }
      }

      return checkResult
    },
    checkBulkUpdate (data) {
      if (!this.$refs.productTable) return

      const targetItems = this.$refs.productTable.pageData
      let product = data.product
      let price = data.price

      let changeItem = product
      targetItems.forEach(item => {
        if (item.asin === product.asin) {
          item.offerPrice = price
          changeItem = item
          changeItem.isChanged = false
        }
      })
      const baseiItems = this.$refs.productTable.originalData
      let amazonOfferPrice = changeItem.offerPrice
      let scOfferPrice = changeItem.scOfferPrice
      let changeItemAsin = changeItem.asin

      let isAmazonOfferValid = amazonOfferPrice !== null && amazonOfferPrice > 0
      let isScOfferValid = scOfferPrice !== null && scOfferPrice > 0
      let hasScOffer = changeItem.hasScOffer

      let offerPriceSelector = $(`#offer-price-${changeItemAsin}`)

      baseiItems.forEach((item) => {
        if (changeItem && (changeItemAsin === item.asin)) {
          let baseAmazonOfferPrice = item.offerPrice
          let baseScOfferPrice = item.scOfferPrice
          let isAmazonOfferChanged = baseAmazonOfferPrice !== amazonOfferPrice
          let isScOfferChanged = baseScOfferPrice !== scOfferPrice

          if (isAmazonOfferChanged) {
            if (isAmazonOfferValid) {
              changeItem.isChanged = true
              offerPriceSelector.show()
              if (hasScOffer && !isScOfferValid) {
                changeItem.isChanged = false
                offerPriceSelector.hide()
              }
            } else {
              changeItem.isChanged = false
              offerPriceSelector.hide()
            }
          } else {
            changeItem.isChanged = false
            offerPriceSelector.hide()
            if (isScOfferChanged && isScOfferValid) {
              changeItem.isChanged = true
              offerPriceSelector.show()
            }
          }
        }
      })
      this.isChangeItems = this.hasProductChanged()
    },
    scCheckBulkUpdate (data) {
      if (!this.$refs.productTable) return

      const targetItems = this.$refs.productTable.pageData
      let product = data.product
      let price = data.price

      let changeItem = product
      targetItems.forEach(item => {
        if (item.asin === product.asin) {
          item.scOfferPrice = price
          changeItem = item
          changeItem.isChanged = false
        }
      })

      const baseiItems = this.$refs.productTable.originalData
      let amazonOfferPrice = changeItem.offerPrice
      let scOfferPrice = changeItem.scOfferPrice
      let changeItemAsin = changeItem.asin

      let isAmazonOfferValid = amazonOfferPrice !== null && amazonOfferPrice > 0
      let isScOfferValid = scOfferPrice !== null && scOfferPrice > 0

      let offerPriceSelector = $(`#offer-price-${changeItemAsin}`)

      baseiItems.forEach((item) => {
        if (changeItem && (changeItemAsin === item.asin)) {
          let baseAmazonOfferPrice = item.offerPrice
          let baseScOfferPrice = item.scOfferPrice
          let isAmazonOfferChanged = baseAmazonOfferPrice !== amazonOfferPrice
          let isScOfferChanged = baseScOfferPrice !== scOfferPrice

          if (isScOfferChanged) {
            if (isScOfferValid && isAmazonOfferValid) {
              changeItem.isChanged = true
              offerPriceSelector.show()
            } else {
              changeItem.isChanged = false
              offerPriceSelector.hide()
            }
          } else {
            changeItem.isChanged = false
            offerPriceSelector.hide()
            if (isAmazonOfferChanged && isAmazonOfferValid) {
              changeItem.isChanged = true
              offerPriceSelector.show()
            }
          }
        }
      })
      this.isChangeItems = this.hasProductChanged()
    },
    acrossCheckBulkUpdate (data) {
      if (!this.$refs.productTable) return

      const targetItems = this.$refs.productTable.pageData
      let product = data.product
      let price = data.price

      let changeItem = product
      targetItems.forEach(item => {
        if (item.asin === product.asin) {
          item.acrossOfferPrice = price
          changeItem = item
          changeItem.isChanged = false
        }
      })

      const baseiItems = this.$refs.productTable.originalData
      let amazonOfferPrice = changeItem.offerPrice
      let acrossOfferPrice = changeItem.acrossOfferPrice
      let changeItemAsin = changeItem.asin

      let isAmazonOfferValid = amazonOfferPrice !== null && amazonOfferPrice > 0
      let isScOfferValid = acrossOfferPrice !== null && acrossOfferPrice > 0

      let offerPriceSelector = $(`#offer-price-${changeItemAsin}`)

      baseiItems.forEach((item) => {
        if (changeItem && (changeItemAsin === item.asin)) {
          let baseAmazonOfferPrice = item.offerPrice
          let baseAcrossOfferPrice = item.acrossOfferPrice
          let isAmazonOfferChanged = baseAmazonOfferPrice !== amazonOfferPrice
          let isScOfferChanged = baseAcrossOfferPrice !== acrossOfferPrice

          if (isScOfferChanged) {
            if (isScOfferValid && isAmazonOfferValid) {
              changeItem.isChanged = true
              offerPriceSelector.show()
            } else {
              changeItem.isChanged = false
              offerPriceSelector.hide()
            }
          } else {
            changeItem.isChanged = false
            offerPriceSelector.hide()
            if (isAmazonOfferChanged && isAmazonOfferValid) {
              changeItem.isChanged = true
              offerPriceSelector.show()
            }
          }
        }
      })
      this.isChangeItems = this.hasProductChanged()
    },
    hasProductChanged () {
      const targetItems = this.$refs.productTable.pageData
      let targetItemsLength = targetItems.length
      let hasItemChanged = false
      let noItemChangedInvalid = true

      for (let index = 0; index < targetItemsLength; index++) {
        let item = targetItems[index]
        if (item.isChanged) {
          hasItemChanged = true
          break
        }
      }

      for (let i = 0; i < targetItemsLength; i++) {
        let product = targetItems[i]
        let amazonOfferPrice = product.offerPrice
        let scOfferPrice = product.scOfferPrice
        let hasScOffer = product.hasScOffer
        if (!product.isParent) {
          if (amazonOfferPrice === null || parseInt(amazonOfferPrice) <= 0) {
            noItemChangedInvalid = false
            break
          }
          if (hasScOffer && (scOfferPrice === null || parseInt(scOfferPrice) <= 0)) {
            noItemChangedInvalid = false
            break
          }
        }
      }

      return hasItemChanged && noItemChangedInvalid
    },
    openUploaderModal (asin, dropboxShareUrl) {
      this.asin = asin
      this.dropboxShareUrl = dropboxShareUrl
    },
    closeUploaderModal () {
      this.asin = ''
      this.dropboxShareUrl = ''
      $('#imageadd').modal('hide')
    },
    isEmptyObj (obj) {
      return Util.isEmptyObj(obj)
    },
    formatAmount (value) {
      return (value === null || typeof value === 'undefined' || value === 0) ? '-' : `${Util.formatMoney(value)}`
    },
    formatQuantity (value) {
      return (value === null || typeof value === 'undefined' || value === 0) ? '-' : `${Util.formatMoney(value)}`
    },
    expectedAmount (offerPrice) {
      const coefficient = this.extraData && this.extraData.coefficient ? this.extraData.coefficient : 1.3
      const tmpOfferPrice = Math.round(offerPrice)
      if (offerPrice !== null && offerPrice > 0 && tmpOfferPrice.toString().length <= 6) {
        return this.formatAmount(offerPrice * coefficient)
      }
      return ' -'
    },
    scExpectedAmount (offerPrice) {
      const coefficient = this.extraData && this.extraData.coefficient ? this.extraData.coefficient : 1.3
      const tmpOfferPrice = Math.round(offerPrice)
      if (offerPrice !== null && offerPrice > 0 && tmpOfferPrice.toString().length <= 6) {
        return this.formatAmount(offerPrice * coefficient)
      }
      return ' -'
    },
    deleteProduct () {
      let self = this
      const items = self.checkedItems
      let logParams = {
        name: eventCode.manage_products.list_tab.click_delete_all_button,
        properties: {
          deletedAsins: items
        }
      }
      EventService.postTrackLog(logParams)

      let product = {
        record: {
          asins: items
        }
      }
      self.checkedItems = []
      self.loader = self.$loading.show()
      self.closeAlert()
      ProductService.deleteProduct(product)
        .then(response => {
          let objectOriginalData = {}
          self.originalData.filter((originalItem) => {
            objectOriginalData[originalItem.asin] = originalItem
          })
          items.forEach(function (asin) {
            const deleteProduct = objectOriginalData[asin]
            self.$refs.productTable.handleData(deleteProduct, 'delete')
          })
          this.$emit('handleRefreshAmazonTable', true)
          self.checkedItems = []
          self.checkAll = false
          self.loader && self.loader.hide()
        })
        .catch(err => {
          self.loadingButton = false
          self.loader && self.loader.hide()
          self.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
    },
    // 商品名・Amazon価格・在庫の更新を行う
    async reRefreshTable (hasLoading = false) {
      const self = this
      if (hasLoading) {
        self.loader = self.$loading.show()
      }
      const response = await ProductService.getGroupProducts()
      var originalData = self.$refs.productTable.originalData
      var pageData = self.$refs.productTable.pageData
      var defaultData = self.$refs.productTable.defaultData
      var allData = self.$refs.productTable.$refs.pagination.allData
      var displayData = self.$refs.productTable.$refs.pagination.data
      if (response) {
        response.forEach(function (item) {
          var displayItem = displayData.find(data => data.asin === item.asin)
          if (displayItem) {
            displayItem.productName = item.productName
            displayItem.amazonPrice = item.amazonPrice
            displayItem.numberOfStock = item.numberOfStock
            displayItem.dropboxShareUrl = item.dropboxShareUrl
            displayItem.scOfferPrice = item.scOfferPrice
            displayItem.acrossOfferPrice = item.acrossOfferPrice
            displayItem.offerPrice = item.offerPrice
          }
          var allItem = allData.find(data => data.asin === item.asin)
          if (allItem) {
            allItem.productName = item.productName
            allItem.amazonPrice = item.amazonPrice
            allItem.numberOfStock = item.numberOfStock
            allItem.dropboxShareUrl = item.dropboxShareUrl
            allItem.scOfferPrice = item.scOfferPrice
            allItem.acrossOfferPrice = item.acrossOfferPrice
            allItem.offerPrice = item.offerPrice
          }
          var originItem = originalData.find(data => data.asin === item.asin)
          if (originItem) {
            originItem.productName = item.productName
            originItem.amazonPrice = item.amazonPrice
            originItem.numberOfStock = item.numberOfStock
            originItem.dropboxShareUrl = item.dropboxShareUrl
            originItem.scOfferPrice = item.scOfferPrice
            originItem.acrossOfferPrice = item.acrossOfferPrice
            originItem.offerPrice = item.offerPrice
          }
          var pageItem = pageData.find(data => data.asin === item.asin)
          if (pageItem) {
            pageItem.productName = item.productName
            pageItem.amazonPrice = item.amazonPrice
            pageItem.numberOfStock = item.numberOfStock
            pageItem.dropboxShareUrl = item.dropboxShareUrl
            pageItem.scOfferPrice = item.scOfferPrice
            pageItem.acrossOfferPrice = item.acrossOfferPrice
            pageItem.offerPrice = item.offerPrice
          }
          var defaultItem = defaultData.find(data => data.asin === item.asin)
          if (defaultItem) {
            defaultItem.productName = item.productName
            defaultItem.amazonPrice = item.amazonPrice
            defaultItem.numberOfStock = item.numberOfStock
            defaultItem.dropboxShareUrl = item.dropboxShareUrl
            defaultItem.scOfferPrice = item.scOfferPrice
            defaultItem.acrossOfferPrice = item.acrossOfferPrice
            defaultItem.offerPrice = item.offerPrice
          }
        })
      }
      self.loader.hide()
    },
    async reApplyProduct (data) {
      let product = {
        record: {
          asin: data.asin,
          offerPrice: data.offerPrice
        }
      }
      let logParams = {
        name: eventCode.manage_products.list_tab.click_reapply_button,
        properties: {
          asin: data.asin
        }
      }
      this.loader = this.$loading.show()
      try {
        const response = await ProductService.reApplyProduct(product)
        if (response) {
          this.$refs.productTable.handleData(response.product, 'update')
        }
        this.loader && this.loader.hide()
        EventService.postTrackLog(logParams)
      } catch (err) {
        EventService.postTrackLog(logParams)
        this.loader && this.loader.hide()
        this.$store.commit('toggleModal', {
          show: true,
          message: err
        })
      }
    },
    showAlert () {
      this.modalDeleteAllItemsScrollNumber = $(window).scrollTop()
      const originalData = this.$refs.productTable.originalData
      this.originalData = [...originalData]
      this.isShowAlert = true
    },
    closeAlert () {
      this.isShowAlert = false
      $('#delete-alert').modal('hide')
      $('#delete-alert').on('hidden.bs.modal', () => {
        window.scrollTo(0, this.modalDeleteAllItemsScrollNumber)
      })
    },
    async updateOfferPrice (data) {
      let asin = data.asin
      let changedOfferPrice = data.offerPrice !== null && data.offerPrice > 0 && data.offerPrice.toString().length <= 6
      let changedScOfferPrice = data.scOfferPrice !== null && data.scOfferPrice > 0 && data.scOfferPrice.toString().length <= 6
      if (changedOfferPrice || changedScOfferPrice) {
        this.loader = this.$loading.show()
        let product = {
          record: {
            asin: asin,
            offerPrice: data.offerPrice,
            scOfferPrice: data.scOfferPrice,
            acrossOfferPrice: data.acrossOfferPrice,
            ean: data.ean && data.ean.toString().length > 0 ? data.ean : null
          }
        }

        let oldProductData = {
          asin: asin,
          offerPrice: data.offerPrice,
          scOfferPrice: data.scOfferPrice,
          acrosssOfferPrice: data.acrosssOfferPrice,
          ean: data.ean && data.ean.toString().length > 0 ? data.ean : null
        }
        let logParams = {
          name: eventCode.manage_products.list_tab.click_save_button,
          properties: {
            oldData: oldProductData,
            newData: product.record
          }
        }
        EventService.postTrackLog(logParams)

        try {
          await ProductService.updateProduct(product)
          this.loader && this.loader.hide()
          this.$refs.productTable.$refs.pagination.updateOriginalData(data)
          setTimeout(() => {
            this.checkBulkUpdate({
              product: data,
              price: data.offerPrice
            })
            this.scCheckBulkUpdate({
              product: data,
              price: data.scOfferPrice
            })
            this.acrossCheckBulkUpdate({
              product: data,
              price: data.acrossOfferPrice
            })
          }, 300)
        } catch (err) {
          this.loader && this.loader.hide()
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        }
      }
    },
    async updateProducts () {
      let changedProducts = []
      let changedRecords = []
      let logParamsProperties = []

      const baseiItems = this.$refs.productTable.originalData
      const targetItems = this.$refs.productTable.pageData
      baseiItems.forEach((item) => {
        if (!item.isParent) {
          let changeItem = targetItems.find(data => data.asin === item.asin)
          if (changeItem && (item.offerPrice !== changeItem.offerPrice || item.scOfferPrice !== changeItem.scOfferPrice || item.acrossOfferPrice !== changeItem.acrossOfferPrice)) {
            let asin = changeItem.asin
            let changedOfferPrice = changeItem.offerPrice
            let changedScOfferPrice = changeItem.scOfferPrice
            let changedAcrossOfferPrice = changeItem.acrossOfferPrice

            changedProducts.push({
              asin: asin,
              ean: changeItem.ean && changeItem.ean.toString().length > 0 ? changeItem.ean : null,
              offerPrice: changedOfferPrice,
              scOfferPrice: changedScOfferPrice,
              acrossOfferPrice: changedAcrossOfferPrice
            })

            logParamsProperties.push({
              newData: {
                asin: asin,
                ean: changeItem.ean && changeItem.ean.toString().length > 0 ? changeItem.ean : null,
                offerPrice: changedOfferPrice,
                scOfferPrice: changedScOfferPrice,
                acrossOfferPrice: changedAcrossOfferPrice
              },
              oldData: {
                asin: asin,
                ean: item.ean && item.ean.toString().length > 0 ? item.ean : null,
                offerPrice: item.offerPrice,
                scOfferPrice: item.scOfferPrice,
                acrossOfferPrice: changedAcrossOfferPrice
              }
            })
            changedRecords.push(changeItem)
          }
        }
      })

      let product = {
        record: {
          changedProducts: changedProducts
        }
      }
      if (product.record.changedProducts.length) {
        let logParams = {
          name: eventCode.manage_products.list_tab.click_save_all_button,
          properties: {
            logParamsProperties
          }
        }
        EventService.postTrackLog(logParams)

        try {
          this.loader = this.$loading.show()
          await ProductService.updateProducts(product)
          this.loader && this.loader.hide()
          this.search = ''
          this.filters.keyword = this.search
          this.filters.judgmentStatus = ''
          this.filters.amountReceived = ''
          this.filters.stockStatus = ''
          this.filters.warehouse = ['Amazon', 'salmonAcross', 'salmonSc']
          this.checkedItems = []
          this.checkAll = false
          this.isChangeItems = false

          changedRecords.forEach((changedRecord) => {
            this.$refs.productTable.$refs.pagination.updateOriginalData(changedRecord)
            this.$refs.productTable.$refs.pagination.allData.filter((allDataItem) => {
              if (allDataItem.asin === changedRecord.asin) {
                allDataItem.offerPrice = changedRecord.offerPrice
                allDataItem.scOfferPrice = changedRecord.scOfferPrice
                allDataItem.acrossOfferPrice = changedRecord.acrossOfferPrice
              }
            })
            setTimeout(() => {
              this.checkBulkUpdate({
                product: changedRecord,
                price: changedRecord.offerPrice
              })
              this.scCheckBulkUpdate({
                product: changedRecord,
                price: changedRecord.scOfferPrice
              })
              this.acrossCheckBulkUpdate({
                product: changedRecord,
                price: changedRecord.acrossOfferPrice
              })
            }, 300)
          })
        } catch (err) {
          this.loader && this.loader.hide()
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        }
      }
    },
    init () {
      let self = this
      self.getSellerInfo({ check_invalid_setting_sp_account: `true` })
    },
    refreshCheckAll () {
      const items = this.$refs.productTable.pageData
      if (this.checkedItems.length === items.length) {
        this.checkAll = true
      } else {
        this.checkAll = false
      }
    },
    sortExpectedAmount (data, order) {
      if (!order) {
        return [...data]
      } else if (order === 'desc') {
        return [...data].sort((before, after) => before.offerPrice - after.offerPrice)
      }
      return [...data].sort((before, after) => after.offerPrice - before.offerPrice)
    },
    openSearch () {
      let logParams = {
        name: eventCode.manage_products.list_tab.click_filter_button,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      this.openSearchModal = true
      $('#search-modal').modal('show')
    },
    closeSearch () {
      this.openSearchModal = false
      $('#search-modal').modal('hide')
    },
    onHandleSearch () {
      this.checkAll = false
      this.checkedItems = []

      if ((this.filters.keyword !== this.search)) {
        this.privateItemLoader = this.$loading.show()
        this.filters.keyword = this.search
      }
      let logParams = {
        name: eventCode.manage_products.list_tab.click_search_button,
        properties: {
          keyword: this.filters.keyword
        }
      }
      EventService.postTrackLog(logParams)
    },
    checkBoxAll (value) {
      const items = this.$refs.productTable.defaultData
      this.checkAll = value
      this.checkedItems = []
      this.parentCheckedItems = []
      var _self = this
      if (this.checkAll) {
        items.forEach(function (item) {
          _self.checkedItems.push(item.asin)
        })
      }
    },
    refreshCheckedAllChild (event) {
      const items = this.$refs.productTable.defaultData
      var _self = this
      items.forEach(function (item) {
        var checkedItems = _self.checkedItems
        if (item.parentAsin && item.parentAsin === event.target.value) {
          if (event.target.checked) {
            _self.checkedItems.push(item.asin)
          } else {
            _self.checkedItems = checkedItems.filter(result => result !== item.asin)
          }
        }
      })
    },
    handleChangeParentCheckedItems (value) {
      this.parentCheckedItems = value
    },
    async updateProductDeleteFlag (product) {
      this.loader = this.$loading.show()
      let updateProductDeleteFlag = product.deleteFlg === '2' ? '0' : '2'
      let updateProductJudgmentStatus = product.judgmentStatus === '出品中' ? '停止中' : '出品中'
      let logParamsName = eventCode.manage_products.list_tab.update_status_from_selling_to_stop
      if (updateProductDeleteFlag === '0') {
        logParamsName = eventCode.manage_products.list_tab.update_status_from_stop_to_selling
      }
      let logParams = {
        name: logParamsName,
        properties: {
          asin: product.asin
        }
      }
      EventService.postTrackLog(logParams)

      await ProductService.updateProductDeleteFlag({
        record: { asin: product.asin, delete_flg: updateProductDeleteFlag }
      }).then(response => {
        const targetItems = this.$refs.productTable.pageData

        let changeItem = targetItems.find(data => data.asin === product.asin)
        if (changeItem) {
          changeItem.deleteFlg = updateProductDeleteFlag
          changeItem.judgmentStatus = updateProductJudgmentStatus
        }
        this.loader.hide()
      }).catch(err => {
        this.error = err
        this.loader.hide()
      })
    },
    handleGetLatestProducts () {
      this.loader = this.$loading.show()
      this.resetFilters()
      setTimeout(() => {
        this.getLatestProducts()
      }, 500)
    },
    async getLatestProducts () {
      await ProductService.getLatestProducts()
        .then((response) => {
          this.resetValidator = true
          this.$refs.productTable.reload()
          this.$emit('handleRefreshAmazonTable', true)
          this.getSellerInfo({ check_invalid_setting_sp_account: `true` })
        })
        .catch((err) => {
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    async getSellerInfo (params = {}) {
      await SettingService.getSellerInformation(params)
        .then(response => {
          this.$store.commit('setUser', response.seller)
        })
        .catch(err => {
          this.error = err
        })
    },
    deleteProductItem () {
      let asin = this.deleteItem.asin
      if (Object.keys(this.deleteItem).length || asin) {
        let self = this
        let logParams = {
          name: eventCode.manage_products.list_tab.click_delete_button,
          properties: {
            deletedAsins: asin
          }
        }
        EventService.postTrackLog(logParams)

        let product = {
          record: {
            asins: [asin]
          }
        }
        self.loader = self.$loading.show()
        self.closeAlertDeleteOneItem()
        ProductService.deleteProduct(product)
          .then(response => {
            const deleteProduct = self.originalData.find(item => item.asin === asin)
            self.$refs.productTable.handleData(deleteProduct, 'delete')
            this.checkedItems = this.checkedItems.filter(checkedAsin => checkedAsin !== asin)
            this.$emit('handleRefreshAmazonTable', true)
            self.loader && self.loader.hide()
          })
          .catch(err => {
            self.loadingButton = false
            self.loader && self.loader.hide()
            self.$store.commit('toggleModal', {
              show: true,
              message: err
            })
          })
      }
    },
    showAlertDeleteOneItem (product) {
      this.deleteItem = product
      const originalData = this.$refs.productTable.originalData
      this.originalData = [...originalData]
      this.isShowAlertDeleteOneItem = true
    },
    closeAlertDeleteOneItem () {
      this.isShowAlertDeleteOneItem = false
      this.deleteItem = {}
      $('#delete-alert').modal('hide')
    },
    resetFilters () {
      this.search = ''
      this.filters.keyword = ''
      this.filters.judgmentStatus = ''
      this.filters.amountReceived = ''
      this.filters.stockStatus = ''
      this.filters.warehouse = ['Amazon', 'salmonAcross', 'salmonSc']
    },
    clearKeywordSearch () {
      this.search = ''
    },
    async handleClickViewProductAnalytics (product) {
      this.loader = this.$loading.show()
      await AnalyticsService.getProductAnalysisUrl({asin: product.asin})
        .then((response) => {
          window.open(response.data, '_blank')
        })
        .catch((error) => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
      this.loader && this.loader.hide()
    },
    toggleAllCollapseProduct (variationDisplaySetting) {
      const variationDisplaySettingOn = '1'
      const variationDisplaySettingOff = '0'
      if (variationDisplaySetting === variationDisplaySettingOff) {
        $('#product-list .collapse').addClass('in')
        $('#product-list .btn-collapse-expand').addClass('btn-collapse')
        $('#product-list .btn-collapse-expand').removeClass('btn-expand')
        $('#product-list .btn-collapse-expand .collapse-icon').addClass('fa-caret-up')
        $('#product-list .btn-collapse-expand .collapse-icon').removeClass('fa-caret-down')
        $('#product-list .btn-collapse-expand .collapse-text').text('バリエーションを非表示')
      }
      if (variationDisplaySetting === variationDisplaySettingOn) {
        $('#product-list .collapse').removeClass('in')
        $('#product-list .btn-collapse-expand').removeClass('btn-collapse')
        $('#product-list .btn-collapse-expand').addClass('btn-expand')
        $('#product-list .btn-collapse-expand .collapse-icon').removeClass('fa-caret-up')
        $('#product-list .btn-collapse-expand .collapse-icon').addClass('fa-caret-down')
        $('#product-list .btn-collapse-expand .collapse-text').text('バリエーションを表示')
      }
    },
    changeVariationDisplaySettingStatus (value) {
      const variationDisplaySetting = this.$store.getters.getUser.variationDisplaySetting
      if (variationDisplaySetting !== value) {
        this.toggleAllCollapseProduct(variationDisplaySetting)
        const checkboxVariationDisplaySettingElements = $('[id^="variation-display-setting-status-"]')
        checkboxVariationDisplaySettingElements.each((index, element) => {
          $(element).attr('disabled', 'disabled')
        })
        UserService.updateVariationDisplaySetting({ variation_display_setting: value })
          .then(response => {
            this.$store.commit('setVariationDisplaySetting', value)
            checkboxVariationDisplaySettingElements.each((index, element) => {
              $(element).removeAttr('disabled')
            })
          })
          .catch(err => {
            this.loader && this.loader.hide()
            this.$store.commit('toggleModal', {
              show: true,
              message: err
            })
          })
      }
    },
    checkVariationDisplaySetting (value) {
      return this.$store.getters.getUser.variationDisplaySetting === value
    },
    handleImageUploadMouseOver (event) {
      $(event.target).siblings('.image-uploader-bubble').show()
    },
    handleImageUploadMouseLeave (event) {
      $(event.target).siblings('.image-uploader-bubble').hide()
    },
    handleAnalyticsMouseOver (event) {
      $(event.target).siblings('.product-analytics-bubble').show()
    },
    handleAnalyticsMouseLeave (event) {
      $(event.target).siblings('.product-analytics-bubble').hide()
    },
    fetchedDataLoading () {
      this.privateItemLoader && this.privateItemLoader.hide()
    },
    openUpgradePlanModal () {
      this.isShowUpgradePlanModal = true
      $('#upgrade-plan-modal').modal('show')
    },
    closeUpgradePlanModal () {
      this.isShowUpgradePlanModal = false
      $('#upgrade-plan-modal').modal('hide')
    },
    openChangeAmountReceivedModal () {
      this.isShowChangeAmountReceivedModal = true
      $('#change-amount-received-modal').modal('show')
    },
    closeChangeAmountReceivedModal () {
      this.isShowChangeAmountReceivedModal = false
      $('#change-amount-received-modal').modal('hide')
    },
    openModalUpload () {
      let logParams = {}
      logParams = {
        name: eventCode.manage_products.list_tab.click_bulk_change_by_csv,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      if (this.isBasicPlan) {
        this.openUpgradePlanModal()
      } else {
        this.isShowUploadModal = true
      }
    },
    closeUploadModal () {
      this.isShowUploadModal = false
      $('#upload-csv-modal').modal('hide')
    },
    closeConfirmChangeModal () {
      this.isShowConfirmChangeModal = false
      $('#confirm-change-price-modal').modal('hide')
    },
    closeChangePriceCompleteModal () {
      $('#myModal').modal('hide')
      this.isShowChangePriceCompleteModal = false
    },
    reUpload () {
      this.closeConfirmChangeModal()
      this.openModalUpload()
    },
    handleChangeAmountReceived () {
      let logParams = {}
      logParams = {
        name: eventCode.manage_products.list_tab.click_change_amount_received_button,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      if (this.isBasicPlan) {
        this.openUpgradePlanModal()
      } else {
        this.openChangeAmountReceivedModal()
      }
    },
    handleCheckSellmonScOffer (val) {
      this.hasSellmonScOffers = val
    },
    handleCheckSellmonAcrossOffer (val) {
      this.hasSellmonAcrossOffers = val
    },
    async handleClickBulkUpdate (params) {
      let logParams = {}
      logParams = {
        name: eventCode.manage_products.list_tab.click_bulk_update_button,
        properties: params.record
      }
      EventService.postTrackLog(logParams)
      this.loader = this.$loading.show()
      try {
        await ProductService.updateAmountReceived(params)
        await this.reRefreshTable()
        this.resetFilters()
      } catch (error) {
        this.$store.commit('toggleModal', {
          show: true,
          message: error
        })
      } finally {
        this.loader && this.loader.hide()
        this.closeChangeAmountReceivedModal()
      }
    },
    getJudgmentStatusClass (row) {
      let judgmentStatusCode = row.judgmentStatusCode
      let statusSuccess = ['2']
      let statusWarning = ['0', '1']
      let statusDanger = ['8', '9']
      if (!judgmentStatusCode || (judgmentStatusCode === '2' && row.deleteFlg.includes(['0', '2']))) {
        return 'judgment-status-not-listed'
      }
      if (statusSuccess.includes(judgmentStatusCode)) {
        return 'judgment-status-success'
      } else if (statusWarning.includes(judgmentStatusCode)) {
        return 'judgment-status-warning'
      } else if (statusDanger.includes(judgmentStatusCode)) {
        return 'judgment-status-danger'
      }
    },
    getReviewDays (item) {
      if (item.reviewDays <= 0) {
        return '少し'
      }

      return `${item.reviewDays}日`
    },
    settingSearch (filters) {
      let logParams = {}
      logParams = {
        name: eventCode.manage_products.list_tab.click_setting_filter_button,
        properties: filters
      }
      EventService.postTrackLog(logParams)
      this.filters = {...filters}
      this.closeSearch()
      this.$refs.productTable.resetHeaderTabProduct()
    },
    handleDownloadTemplate () {
      let logParams = {}
      logParams = {
        name: eventCode.manage_products.list_tab.click_download_template,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      ProductService.downloadAmountReceivedTemplate({}, this.getFileName())
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    getFileName () {
      let sellerid = this.$store.getters.getUser.sellerId
      let reportTime = moment(new Date()).format('YYYYMMDDHHmmss')
      let filename = `itempriceList_${sellerid}_${reportTime}.csv`
      return filename
    },
    handleUpload () {
      let logParams = {}
      logParams = {
        name: eventCode.manage_products.list_tab.click_upload,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    },
    handleUploadSuccess (response) {
      this.confirmChangeData = response.records.data.data
      this.disableSubmitChangePrice = response.records.data.hasError
      this.closeUploadModal()
      this.isShowConfirmChangeModal = true
    },
    async handleUpdateAmountReceivedByFile () {
      let logParams = {}
      logParams = {
        name: eventCode.manage_products.list_tab.click_submit_change_by_csv,
        properties: this.confirmChangeData
      }
      EventService.postTrackLog(logParams)

      this.loader = this.$loading.show()
      try {
        await ProductService.updateAmountReceivedByCsv({ confirmChangeData: this.confirmChangeData })
        await this.reRefreshTable()
        this.isShowChangePriceCompleteModal = true
      } catch (error) {
        this.$store.commit('toggleModal', {
          show: true,
          message: error
        })
      } finally {
        this.loader && this.loader.hide()
        this.closeConfirmChangeModal()
      }
    },
    sliceProductName (isParent = false, productName) {
      if (isParent) {
        return productName
      }
      if (!productName) {
        return ''
      }
      const length = 80
      if (productName.length <= length) return productName

      return productName.slice(0, length / 2) + ' ... ' + productName.slice(-(length / 2))
    }
  },
  watch: {
    $route (routeValue) {
      if (!this.noEvidenceImage) {
        this.$refs.productTable.resetHeaderTabProduct()
        if (this.hasRefreshGroupTable && routeValue.params.tab === 'list' && !this.hasAmazonthrottleError) {
          this.search = ''
          this.filters.keyword = this.search
          this.filters.judgmentStatus = ''
          this.filters.amountReceived = ''
          this.filters.warehouse = ['Amazon', 'salmonAcross', 'salmonSc']
          this.filters.stockStatus = ''
          setTimeout(() => {
            this.$refs.productTable.reload()
            this.$emit('handleNotRefreshGroupTable', false)
          }, 500)
        }
      }
    }
  },
  mounted () {
    let self = this
    self.loader && self.loader.hide()
    this.$events.listen('noAmazon', (value) => {
      self.haveAmazonInfo = value
    })
    this.$events.listen('done', (url) => {
      if (url === 'ParentProductGroup') {
        self.loader && self.loader.hide()
        self.loadingButton = false
      }
    })
    this.$events.listen('apiSuccess', (url) => {
      if ((url === 'ParentProductGroup') && this.resetValidator) {
        this.$validator.reset()
        this.resetValidator = false
      }
    })
    if (this.currentTab && this.currentTab === 'list') {
      let logParams = {
        name: eventCode.manage_products.list_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
    this.$events.listen('amazonThrottleError', (value) => {
      this.hasAmazonthrottleError = value
    })
  },
  beforeDestroy () {
    this.$events.remove('noAmazon')
    this.$events.remove('done')
    this.$events.remove('apiSuccess')
    this.loader && this.loader.hide()
  }
}
</script>

<style scoped>
.group-table__product_img {
  width: auto;
  max-width: 75px;
  max-height: 75px;
  object-fit: contain;
}
.box-toggle-judgment-status {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.7rem;
  margin-top: 10px;
  padding-left: 1rem;
  -webkit-print-color-adjust: exact;
}
.box-toggle-judgment-status .judgment-status-input {
  box-sizing: border-box;
  padding: 0;
  display: none;
}
.judgment-status-label {
  position: relative;
  vertical-align: top;
  display: inline-block;
  margin-bottom: 0.5rem;
}
.judgment-status-label:hover {
  cursor: pointer;
}
.judgment-status-input:checked~.judgment-status-label::before {
  color: #fff;
  border-color: #f8c330;
  background-color: #f8c330;
}
.box-toggle-judgment-status .judgment-status-label::before {
  left: -2.25rem;
  width: 3.2rem;
  pointer-events: all;
  border-radius: 1.5rem;
}
.judgment-status-label::before {
  position: absolute;
  top: 0.2rem;
  display: block;
  height: 1.7rem;
  content: "";
  background-color: #fff;
  border: 1px solid #7b7b7b;
  transition: background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.box-toggle-judgment-status .judgment-status-input:checked~.judgment-status-label::after {
  background-color: #fff;
  transform: translateX(1.75rem);
}
.box-toggle-judgment-status .judgment-status-label::after {
  position: absolute;
  top: 0.2rem;
  display: block;
  content: "";
  background: 50%/50% 50% no-repeat;
  top: calc(0.25rem + 2.5px);
  left: calc(-2.25rem + 2px);
  width: calc(1.5rem - 4px);
  height: calc(1.5rem - 4px);
  background-color: #000;
  border-radius: 0.5rem;
  transition: transform .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-transform .15s ease-in-out;
}
.btn-delete-product {
  background-color: #ffffff;
  border: 1px solid #a94442;
  color: #a94442;
  cursor: pointer;
}
.btn-delete-product:hover {
  color: #ffffff;
  background-color: #a94442;
}
.analytics-icon img {
  width: 40px;
  height: auto;
  cursor: pointer;
}
.analytics-icon .btn {
  padding: 5px 20px;
  margin-top: 10px;
}
.text-price {
  color: #B12704;
}
.text-price-number {
  font-size: 20px;
  font-weight: bold;
}
.box-search-display, .box-search-setting{
  border-left: solid 3px #008CC6;
  margin-left: 65px;
  width: 382px;
  margin-right: 15px;
}
.search-header {
  width: 150px;
  border-bottom: solid 2px #008CC6;
}
.custom-tooltip {
  position: relative;
  display: inline-block;
}

.custom-tooltip .custom-tooltiptext {
  visibility: hidden;
  width: 500px;
  background-color: #555;
  color: #fff;
  text-align: left;
  padding: 5px 10px;
  position: absolute;
  z-index: 100;
  bottom: 125%;
  left: 0%;
  margin-left: -60px;
  opacity: 0;
  transition: opacity 0.3s;
}

.custom-tooltip .custom-tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

.custom-tooltip:hover .custom-tooltiptext {
  visibility: visible;
  opacity: 1;
}
.judgment-status-not-listed {
  color: #f2f2f2;
  background-color: #a6a6a6;
}
.judgment-status-danger {
  color: #fff;
  background-color: #c00000;
}
.box-warehouse {
  display: flex;
  align-items: center;
  align-content: center;
  flex-direction: column;
  justify-content: space-between;
  width: 280px;
  min-height: 130px;
  max-height: 150px;
  padding: 5px;
  border: 1px solid #ff9900;
  border-radius: 8px;
  background-image: linear-gradient(0deg, #eff1f2 50%, #fff 50%);
  font-size: 12px;
}
.box-warehouse-sc {
  border: 1px solid #00b7bd;
}
.box-warehouse-across {
  border: 1px solid #008CC6;
}
.product-input-money {
  width: 100px;
  height: 35px;
  color: #800000;
  font-weight: bold;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.text-primary {
  color: #2e75b6;
}
.text-rotate {
  display: inline-block;
  transform: rotate(-30deg);
}
.expected-amount {
  text-align: right;
  padding: 3px 15px;
}
.dropdown .dropdown-menu, .dropup .dropdown-menu {
  display: none;
  position: absolute;
  list-style: circle;
  top: 0;
  left: 120%;
  background: #595959;
  min-width: 250px;
  z-index: 1000;
  padding: 10px 30px;
  margin: unset;
  color: #fff;
  border-radius: unset;
}
.dropup .dropdown-menu {
  top: unset;
  bottom: 0;
  left: 120%;
}
.dropdown:hover .dropdown-menu, .dropup:hover .dropdown-menu {
  display: block;
}
.dropdown-menu li {
  border-bottom: 1px dotted #fff;
  margin-bottom: 10px;
}
.tooltip-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.tooltip-text {
  visibility: hidden;
  background-color: #555;
  color: #fff;
  text-align: left;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  position: absolute;
  z-index: 1;
  top: 110%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  width: 70%;
}
.tooltip-text::after {
  content: '';
  position: absolute;
  top: -10px;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #555 transparent;
}
.tooltip-wrapper:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
@media (max-width: 768px) {
  .content {
    padding: 15px !important;
  }
}
@media (max-width: 576px) {
  .content {
    padding: 5px !important;
  }
}
@media (max-width: 1400px) {
  .box-search-display-setting {
      display: flex;
  }
}
</style>
<style>
.content {
  overflow: unset;
}
</style>



// WEBPACK FOOTER //
// src/view/productsNew/ProductsNewGroupedByAsin.vue